import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Outlet, useOutletContext } from 'react-router';
import { useAssetReadOnly } from '@/context/AssetReadOnlyContext';
import type { AssetContextType } from '../AssetMainOutlet';

export function AssetDetailOutlet() {
	const context = useOutletContext<AssetContextType>();
	const { t } = useTranslation();
	// Only for the organization: a deleted asset is read-only too, and says so in its own banner
	const { isOrganizationInactive } = useAssetReadOnly();

	return (
		<>
			{isOrganizationInactive && (
				<div
					className="flex items-center gap-2 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-200"
				>
					<Lock className="size-4 shrink-0" />
					{t('assets.organization.inactiveReadOnly')}
				</div>
			)}
			<Outlet context={context} />
		</>
	);
}
